import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Alert, Descriptions, Skeleton, Card, Divider } from 'antd';
import dayjs from 'dayjs';

import { IsLoggedIn } from '../../utils/helpers/helpers';

import './style.scss';
import CustomButton from '../../components/CustomButton';
import Title from 'antd/lib/typography/Title';
import { useParams } from 'react-router-dom';
import {
  getPublicAnexoUrl,
  getPublicInfo,
  getPublicRoles,
} from '../../api/module/announcement_contractor';

const periodOptions = {
  1: 'Mensual',
  2: 'Total contrato',
  3: 'Entrega de productos',
  4: 'Otro',
};

const PublicAnnouncement = ({ history }) => {
  const { announcement_id } = useParams();
  const [loadingDocument, setLoadingDocument] = useState(false);

  const [announcement, setAnnouncement] = useState(null);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (IsLoggedIn()) {
      history.push('/');
    } else {
      load();
    }
  }, []);

  const load = async () => {
    try {
      const { data: responseData } = await getPublicInfo(announcement_id);
      const responseRoles = await getPublicRoles(announcement_id);
      setRoles(responseRoles.data);
      setAnnouncement({
        ...responseData,
        fecha_inicio: dayjs(responseData.fecha_inicio),
        fecha_fin: dayjs(responseData.fecha_fin),
      });
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const showDocument = async () => {
    setLoadingDocument(true);
    const { data } = await getPublicAnexoUrl(announcement_id);

    window.open(data.url);

    setLoadingDocument(false);
  };

  return (
    <div className="public-announcement-page">
      {loading === true && (
        <Alert
          message="Cargando información de la convocatoria."
          description="Por favor espere..."
          type="info"
          showIcon
        />
      )}
      <Skeleton loading={loading} active>
        {announcement ? (
          <>
            <Title className={'text-uppercase'} level={2}>
              PREVISUALIZACIÓN de CONVOCATORIA
            </Title>
            <Card
              size={'small'}
              bordered={false}
              title={
                <Title level={3} style={{ whiteSpace: 'normal' }}>
                  {announcement.nombre}
                </Title>
              }
              extra={
                <img
                  src={announcement.organizacion_logo}
                  alt="Logo Organización"
                  style={{ width: 'calc(250px - 20px)' }}
                />
              }
            >
              <Descriptions
                className="description-label-style"
                title="Información de la convocatoria"
                bordered
                column={2}
              >
                <Descriptions.Item label="Organización" span={2}>
                  {announcement.organizacion_nombre}
                </Descriptions.Item>
                <Descriptions.Item
                  label="Proyecto, licitación, concurso u otro"
                  span={2}
                >
                  {announcement.nombre_proyecto}
                </Descriptions.Item>
                <Descriptions.Item label="Número de convocatoria">
                  {announcement.numero}
                </Descriptions.Item>
                <Descriptions.Item label="Archivo anexo de la convocatoria">
                  {announcement.tiene_anexo ? (
                    <CustomButton
                      block
                      type="default"
                      text="Ver"
                      htmlType="button"
                      loading={loadingDocument}
                      onClick={showDocument}
                    />
                  ) : (
                    'Sin adjunto'
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Nombre de la convocatoria" span={2}>
                  {announcement.nombre}
                </Descriptions.Item>
                <Descriptions.Item label="Fecha inicio de la convocatoria">
                  {announcement.fecha_inicio.format('DD - MMMM - YYYY')}
                </Descriptions.Item>
                <Descriptions.Item label="Fecha fin de la convocatoria">
                  {announcement.fecha_fin.format('DD - MMMM - YYYY')}
                </Descriptions.Item>
                <Descriptions.Item
                  label="Descripción de la convocatoria"
                  span={2}
                >
                  {announcement.descripcion.split('\n').map((value) => (
                    <>
                      {value} <br />
                    </>
                  ))}
                </Descriptions.Item>
                <Descriptions.Item label="IMPORTANTE" span={2}>
                  Esta convocatoria podrá ser cerrada/finalizada de forma
                  anticipada una vez se cubran la(s) vacante(s) requerida(s).
                </Descriptions.Item>
              </Descriptions>
            </Card>
            {roles.map((item, index) => (
              <>
                <Divider>
                  <Title level={5}>
                    Cargo / Rol No. {index + 1} - {item.cargo}
                  </Title>
                </Divider>
                <Descriptions
                  className="description-label-style"
                  bordered
                  column={3}
                >
                  <Descriptions.Item
                    label="Observaciones para el cargo"
                    span={3}
                  >
                    {(item.observaciones_cargo || '')
                      .split('\n')
                      .map((value) => (
                        <>
                          {value} <br />
                        </>
                      ))}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={`Remuneración ${
                      item.remuneracion_variable != null ? 'variable' : 'fija'
                    }`}
                    span={3}
                  >
                    {item.remuneracion_variable != null
                      ? item.remuneracion_variable.split('\n').map((value) => (
                          <>
                            {value} <br />
                          </>
                        ))
                      : item.remuneracion_fija != null
                        ? `$ ${item.remuneracion_fija}`.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ',',
                          )
                        : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Período" span={3}>
                    {item.periodo === 4
                      ? item.periodo_cual
                      : periodOptions[item.periodo]}
                  </Descriptions.Item>
                  <Descriptions.Item label="Total vacantes" span={3}>
                    {item.total_vacantes}
                  </Descriptions.Item>
                  <Descriptions.Item label="Tipo contrato" span={3}>
                    {item.tipo_contrato_nombre || 'Por definir'}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={`Duración del proyecto - ${item.unidad_tiempo_texto || ''}`}
                    span={3}
                  >
                    {item.duracion}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="Fecha estimada de inicio de labores"
                    span={3}
                  >
                    {item.fecha_inicio
                      ? dayjs(item.fecha_inicio).format('DD - MMMM - YYYY')
                      : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Estudios" span={3}>
                    {(item.estudios || '').split('\n').map((value) => (
                      <>
                        {value} <br />
                      </>
                    ))}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="Tipo de experiencia laboral"
                    span={3}
                  >
                    {(item.tipo_experiencia_laboral || '')
                      .split('\n')
                      .map((value) => (
                        <>
                          {value} <br />
                        </>
                      ))}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <>
                        Disponibilidad para viajar / desplazarse <br />
                        durante el proyecto
                      </>
                    }
                  >
                    {item.disponibilidad_viajar ? 'Si' : 'No'}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <>
                        Posibilidad de radicarse en <br />
                        otra ciudad durante el proyecto
                      </>
                    }
                  >
                    {item.radicarse_otra_ciudad ? 'Si' : 'No'}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <>
                        Tiempo de experiencia <br />
                        laboral (meses)
                      </>
                    }
                  >
                    {item.tiempo_experiencia_laboral || ''}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="Lugar de realización de labores"
                    span={3}
                  >
                    {item.lugares.map((value) => (
                      <>
                        {value[1]} <br />
                      </>
                    ))}
                  </Descriptions.Item>
                </Descriptions>
                <Descriptions column={3} bordered>
                  <Descriptions.Item
                    label="Aceptar y aplicar a cargo/rol"
                    span={3}
                  >
                    <Button type="primary">
                      <Link to="/">Aceptar y aplicar a cargo rol</Link>
                    </Button>
                  </Descriptions.Item>
                </Descriptions>
              </>
            ))}
          </>
        ) : (
          <Alert
            message="Error"
            description="No ha sido posible mostrar la información de la convocatoria."
            type="warning"
            showIcon
            closable
          />
        )}
      </Skeleton>
    </div>
  );
};

export default PublicAnnouncement;
